import { SaveButton, Toolbar, useSaveContext } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { ScheduleTaskForm } from './types';

export const ProcessTemplateFormToolbar = () => {

  const { saving } = useSaveContext();
  const scheduleTasks = useWatch({ name: 'scheduleTasks' }) as ScheduleTaskForm[] | undefined;
  const hasScheduleTasks = Array.isArray(scheduleTasks) && scheduleTasks.length > 0;

  return (
    <Toolbar>
      <SaveButton disabled={saving || !hasScheduleTasks} />
    </Toolbar>
  );

};
